import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";
import PostHooks from "../../../../Api/PostHooks";
import { useState } from "react";
import { MuiTelInput } from "mui-tel-input";
import AlertComponent from "../../../../Components/AlertComponent";

const GuarantorNominationForm = ({ data, onClose, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, response, request] = PostHooks();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [type, setType] = useState();
  const [msisdn, setMsisdn] = useState();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = async (e) => {
    try {
      if (msisdn === undefined || (msisdn && msisdn.length < 13)) {
        setSnackbar({
          open: true,
          severity: "error",
          message: "Please enter a valid phone number.",
        });
      } else {
        let formData = {
          amount: data.guarantor_saving,
          msisdn: msisdn.replace("+", ""),
          // id_number: e.id_number,
          loan_req_id: data.id,
          asset_name: e.asset_name,
          description: e.description,
          url: "n/a",
          worthyness: e.worthyness,
          type: type,
          guarantorship_entity_id: "",
        };

        const resp = await request({
          url: "/nominate_guarantor",
          body: formData,
        });

        if (resp && resp.status === 200 && resp.data.StatusCode === 0) {
          setSnackbar({
            open: true,
            severity: "success",
            message: "Gurantor Request Successfully!",
          });
          setTimeout(() => {
            onClose();
            onSuccess();
          }, 500);
        } else if (
          resp &&
          (resp.status === 200 || resp.status !== 200) &&
          resp.data.StatusCode !== 0
        ) {
          const errorMessage =
            resp?.data?.StatusMessage ??
            resp?.data?.message ??
            resp.message ??
            "An unexpected error occurred. Please try again.";

          setSnackbar({
            open: true,
            severity: "error",
            message: errorMessage,
          });
        }
      }
    } catch (error) {
      console.log("Guarantor nomination err", error);

      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <div>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl
          fullWidth
          sx={{
            mt: "15px",
          }}
        >
          <InputLabel id="type">Guarantor type</InputLabel>
          <Select
            labelId="type"
            id="type"
            defaultValue=""
            value={type}
            label="Guarantor type"
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem value="other_members">Other members</MenuItem>
            <MenuItem value="assets">Assets</MenuItem>
            <MenuItem value="pool_fund">Pool fund</MenuItem>
          </Select>
        </FormControl>

        {type === "other_members" && (
          <FormControl
            fullWidth
            error={!!errors.id_number}
            sx={{
              mt: "15px",
            }}
          >
            <MuiTelInput
              sx={{
                border: "1px solid black",
              }}
              defaultCountry="KE"
              disableFormatting
              value={msisdn}
              onChange={(e) => setMsisdn(e)}
            />
          </FormControl>
        )}

        {/* 
        <FormControl
          fullWidth
          error={!!errors.id_number}
          sx={{
            mt: "15px",
          }}
        >
          <InputLabel htmlFor="id_number">Id Number</InputLabel>
          <OutlinedInput
            id="id_number"
            type="number"
            {...register("id_number", { required: true })}
            label="Id Number"
            variant="filled"
          />
          {errors.id_number && <FormHelperText>Required</FormHelperText>}
        </FormControl> */}

        {/* <FormControl
          fullWidth
          error={!!errors.amount}
          sx={{
            my: "15px",
          }}
        >
          <InputLabel htmlFor="amount">Amount</InputLabel>
          <OutlinedInput
            id="amount"
            type="number"
            {...register("amount", { required: true })}
            label="Id Number"
            variant="filled"
          />
          {errors.amount && <FormHelperText>Required</FormHelperText>}
        </FormControl> */}

        {type === "assets" && (
          <>
            <FormControl
              fullWidth
              error={!!errors.asset_name}
              sx={{
                mt: "15px",
              }}
            >
              <InputLabel htmlFor="asset_name">Asset name</InputLabel>
              <OutlinedInput
                id="asset_name"
                type="text"
                {...register("asset_name")}
                label="Asset name"
                variant="filled"
                defaultValue=""
              />
              {errors.asset_name && <FormHelperText>Required</FormHelperText>}
            </FormControl>

            <FormControl
              fullWidth
              error={!!errors.description}
              sx={{
                mt: "15px",
              }}
            >
              <InputLabel htmlFor="description">Description</InputLabel>
              <OutlinedInput
                id="description"
                type="text"
                {...register("description")}
                label="Description"
                variant="filled"
                defaultValue=""
              />
              {errors.description && <FormHelperText>Required</FormHelperText>}
            </FormControl>

            <FormControl
              fullWidth
              error={!!errors.worthyness}
              sx={{
                mt: "15px",
              }}
            >
              <InputLabel htmlFor="worthyness">Asset worth</InputLabel>
              <OutlinedInput
                id="worthyness"
                type="number"
                {...register("worthyness")}
                label="Asset worth"
                variant="filled"
                defaultValue=""
                inputProps={{ step: "any", min: 0 }}
              />
              {errors.worthyness && <FormHelperText>Required</FormHelperText>}
            </FormControl>
          </>
        )}

        <Box
          sx={{
            mt: "40px",
            gap: 2,
            display: "flex",
            direction: "row",
            justifyContent: "flex-end",
          }}
        >
          <Button variant="outlined" type="reset" onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={loading}
            color="primary"
            variant="contained"
            type="submit"
          >
            Submit
          </LoadingButton>
        </Box>
      </form>
    </div>
  );
};

export default GuarantorNominationForm;
